import { entityRoutes } from "../../../app/components/EntityBreadcrumbs";

export const getProcessLink = (type: string, id: string | number): string => {
    switch (type) {
        case "VALIDATION":
            return entityRoutes.process(String(id));
        default:
            return `/projectprocess/edit/${id}`;
    }
};